import { render, staticRenderFns } from "./LiveKifus.vue?vue&type=template&id=f14fe3b8&scoped=true&"
import script from "./LiveKifus.vue?vue&type=script&lang=js&"
export * from "./LiveKifus.vue?vue&type=script&lang=js&"
import style0 from "./LiveKifus.vue?vue&type=style&index=0&id=f14fe3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14fe3b8",
  null
  
)

export default component.exports